import React, { Component } from 'react';
import { ViewPropTypes, Dimensions, Text, Platform, Modal, View } from 'react-native'

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import {
  isEmpty as _isEmpty,
  get as _get,
  isFunction as _isFunction,
  isNil as _isNil,
} from 'lodash';
import PropTypes from 'prop-types';

import { QuickActionMenu } from '@vfgroup-oneplatform/foundation/Components';
// import StatusView from '@vfgroup-oneplatform/foundation/Components/StatusView';
import {
  withTheme,
  LightThemeColors,
  getThemeImages,
  Types,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import { AddDataSelector, ResultModal } from '../../Components';
import ExtraLoadingScreen from '../../Components/ExtraLoadingScreen/index';

import styles from './MyPlanExtrasModal.styles';
import ReactNativeModal from 'react-native-modal';
// import usePaymentOnMyPlan, { onPressOpenCardList } from '../../Hooks/usePaymentOnMyPlan'

class MyPlanExtrasModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: this.props.isLoading,
      isResetData: this.props.isResetData,
      isDoneLoading: false,
      paymentTypeSelectedOption: 1,
      paymentAmountSelectedOption: -1,
      modalHeight: 0,
    };
    this.screenHeight = Dimensions.get('window').height;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const prevPropsIsLoading = prevState.isLoading;
    const nextPropsIsLoading = nextProps.isLoading;

    const newState = {};

    if (prevPropsIsLoading !== nextPropsIsLoading) {
      newState.isLoading = nextPropsIsLoading;

      if (!prevPropsIsLoading && nextPropsIsLoading) {
        newState.isDoneLoading = true;
      }
    }

    if (prevState.isResetData !== nextProps.isResetData) {
      if (nextProps.isResetData) {
        newState.isDoneLoading = false;
        newState.paymentTypeSelectedOption = 1;
        newState.paymentAmountSelectedOption = -1;
      }
    }

    if (!_isEmpty(newState)) {
      return newState;
    }

    return null;
  }

  getQamProps = (isLoadingVisible, isResultModalVisible) => {
    const {
      toggleModal,
      isVisible,
      closeModal,
      type,
      title,
      isLoadingSuccessful,
      paymentOptions,
      onBackButtonPress,
      headerStyle,
      theme,
      isPlansExtrasLoading,
      plansExtrasError,
    } = this.props;
    const _images = getThemeImages(theme.name);

    return {
      isVisible,
      toggleModal,
      closeModal,
      title: _get(paymentOptions, 'title', title),
      headerStyle,
      type,
      containerStyle: styles.modalContainer,
      contentContainerStyle: styles.modalContent,
      isBackButton: paymentOptions.isBackButton,
      onBackButtonPress,
      backButtonIcon: _images.ic_arrow_left,
      withCloseButton:
        isLoadingVisible || (isResultModalVisible && isLoadingSuccessful) ? false : true,
      notScrollable: isPlansExtrasLoading || !_isNil(plansExtrasError) || isResultModalVisible,
    };
  };

  getStatusViewProps = () => {
    const { plansExtrasError, plansExtrasErrorScreenProps, theme } = this.props;
    const Images = getThemeImages(theme.name);
    return {
      description: plansExtrasError?.message,
      title: plansExtrasErrorScreenProps?.title,
      image: Images.ic_WarningHiLight_Theme,
      primaryButtonProps: {
        onPress: plansExtrasErrorScreenProps?.onPrimaryBtnPress,
        title: plansExtrasErrorScreenProps?.primaryBtnTitle,
      },
      textStyles: {
        title: styles.titleStyle,
        description: styles.descriptionStyle,
        textContainer: styles.textContainerStyle,
      },
      containerStyle: styles.errorContainerStyle(theme),
    };
  };

  selectPaymentTypeOption = index => {
    this.setState({
      paymentTypeSelectedOption: index + 1,
    });

    this.state.paymentTypeSelectedOption !== index + 1 &&
      this.setState({
        paymentAmountSelectedOption: -1,
      });
  };

  selectPaymentAmountOption = index => {
    this.setState({
      paymentAmountSelectedOption: index + 1,
    });
  };

  setModalHeight = height => {
    const _height = height > 0.85 * this.screenHeight ? 0.7 * this.screenHeight : height;
    this.setState({
      modalHeight: _height,
    });
  };

  handleTryAgainPress = () => {
    const { onTryAgainPress } = this.props;
    if (_isFunction(onTryAgainPress)) {
      const { paymentTypeOptions, paymentAmountFirstTypeOptions, paymentAmountSecondTypeOptions } =
        this.props;
      const paymentAmountOptions =
        this.state.paymentTypeSelectedOption === 1
          ? paymentAmountFirstTypeOptions
          : paymentAmountSecondTypeOptions;
      onTryAgainPress(
        paymentTypeOptions[this.state.paymentTypeSelectedOption - 1],
        paymentAmountOptions[this.state.paymentAmountSelectedOption - 1],
      );
    } else {
      this.setState({
        isLoading: false,
        isDoneLoading: false,
      });
      this.setSelectedOptions();
    }
  };

  handleGoBackPress = () => {
    const { onGoBackPress } = this.props;
    if (_isFunction(onGoBackPress)) {
      onGoBackPress();
    } else {
      this.setState({
        isLoading: false,
        isDoneLoading: false,
      });
      this.setSelectedOptions();
    }
  };

  setSelectedOptions = () => ({
    paymentOption: this.state.paymentTypeSelectedOption,
    paymentAmount: this.state.paymentAmountSelectedOption,
  });

  renderContent = (isLoadingVisible, isResultModalVisible) => {
    const { isPlansExtrasLoading, plansExtrasError } = this.props;

    if (isPlansExtrasLoading) {
      return <ExtraLoadingScreen />;
    } else if (isResultModalVisible) {
      return this.renderResultModal();
    } else if (!isResultModalVisible) {
      return this.renderAddDataSelector(isLoadingVisible);
    }
  };

  renderAddDataSelector = isLoadingVisible => {
    const {
      paymentTypeTitle,
      paymentTypeTitleStyle,
      paymentTypeOptions,
      paymentAmountTitle,
      paymentAmountFirstTypeOptions,
      paymentAmountSecondTypeOptions,
      paymentMethodTitle,
      paymentMethodTitleStyle,
      paymentFooterTitle,
      paymentFooterIcon,
      handlePaymentFooterIconPress,
      paymentFooterFirstTypeDescription,
      paymentFooterSecondTypeDescription,
      confirmButtonType,
      confirmButtonTitle,
      handleConfirmButtonPress,
      cancelButtonType,
      cancelButtonTitle,
      handleCancelButtonPress,
      loadingMessage,
      loadingMessageTextStyle,
      loadingLottieViewStyle,
      isLoadingSuccessful,
      paymentCards,
      defaultPayment,
      onSelectDefaultCard,
      onPressOpenCardList,
      paymentOptions,
      onPressAddCard,
      onPressSaveCard,
      isPaymentMethod,
      renderCustomPaymentMethod,
      footerDescriptionStyle,
      paymentTypeSectionContainerStyle,
      paymentAmountContainerStyle,
      btnsContainerStyle,
    } = this.props;

    return (
      <AddDataSelector
        isLoadingSuccessful={isLoadingSuccessful}
        setSelectedOptions={this.setSelectedOptions}
        getModalHeight={this.setModalHeight}
        paymentTypeTitle={paymentTypeTitle}
        paymentTypeTitleStyle={paymentTypeTitleStyle}
        paymentTypeOptions={paymentTypeOptions}
        selectPaymentTypeOption={this.selectPaymentTypeOption}
        paymentAmountTitle={paymentAmountTitle}
        paymentAmountOptions={
          this.state.paymentTypeSelectedOption === 1
            ? paymentAmountFirstTypeOptions
            : paymentAmountSecondTypeOptions
        }
        selectPaymentAmountOption={this.selectPaymentAmountOption}
        paymentMethodTitle={paymentMethodTitle}
        paymentMethodTitleStyle={paymentMethodTitleStyle}
        paymentFooterTitle={paymentFooterTitle}
        paymentFooterIcon={paymentFooterIcon}
        handlePaymentFooterIconPress={handlePaymentFooterIconPress}
        paymentFooterDescription={
          this.state.paymentTypeSelectedOption === 1
            ? paymentFooterFirstTypeDescription
            : paymentFooterSecondTypeDescription
        }
        confirmButtonType={confirmButtonType}
        confirmButtonTitle={confirmButtonTitle}
        handleConfirmButtonPress={handleConfirmButtonPress}
        cancelButtonType={cancelButtonType}
        cancelButtonTitle={cancelButtonTitle}
        handleCancelButtonPress={handleCancelButtonPress}
        paymentCards={paymentCards}
        defaultPayment={defaultPayment}
        onSelectDefaultCard={onSelectDefaultCard}
        onPressOpenCardList={onPressOpenCardList}
        paymentOptions={paymentOptions}
        onPressAddCard={onPressAddCard}
        onPressSaveCard={onPressSaveCard}
        isPaymentMethod={isPaymentMethod}
        renderCustomPaymentMethod={renderCustomPaymentMethod}
        footerDescriptionStyle={footerDescriptionStyle}
        paymentTypeSectionContainerStyle={paymentTypeSectionContainerStyle}
        paymentAmountContainerStyle={paymentAmountContainerStyle}
        btnsContainerStyle={btnsContainerStyle}
        isLoadingVisible={isLoadingVisible} //
        loadingLottieViewStyle={loadingLottieViewStyle}
        loadingMessage={loadingMessage}
        loadingMessageTextStyle={loadingMessageTextStyle}
        modalHeight={this.state.modalHeight}
      />
    );
  };

  renderResultModal = () => {
    const {
      isLoadingSuccessful,
      doneLoadingFailureIcon,
      doneLoadingMainTitle,
      doneLoadingMainTitleStyle,
      doneLoadingSubTitle,
      doneLoadingSubtitlePlaceholders,
      doneLoadingSubTitleStyle,
      doneLoadingPrimaryButtonType,
      doneLoadingPrimaryButtonText,
      doneLoadingPrimaryButtonAction,
      withDoneLoadingSecondaryButton,
      doneLoadingSecondaryButtonType,
      doneLoadingSecondaryButtonText,
      doneLoadingSecondaryButtonAction,
      theme,
    } = this.props;

    const resultModalFirstButtonProps = {
      firstButtonType: doneLoadingPrimaryButtonType,
      firstButtonTitle: doneLoadingPrimaryButtonText,
      handleFirstButtonPress: doneLoadingPrimaryButtonAction || this.handleTryAgainPress,
    };

    const resultModalSecondButtonProps = {
      withSecondButton: withDoneLoadingSecondaryButton,
      secondButtonType: doneLoadingSecondaryButtonType,
      secondButtonTitle: doneLoadingSecondaryButtonText,
      handleSecondButtonPress: doneLoadingSecondaryButtonAction || this.handleGoBackPress,
    };

    return (
      <ResultModal
        source={
          theme.name === 'light'
            ? require('../../../Themes/Lottie/Tick_Red_Light.json')
            : require('../../../Themes/Lottie/Tick_Red_Dark.json')
        }
        autoPlay
        loop={false}
        isLoadingSuccessful={isLoadingSuccessful}
        mainTitle={doneLoadingMainTitle}
        mainTitleStyle={doneLoadingMainTitleStyle}
        subTitle={doneLoadingSubTitle}
        subTitlePLaceholders={doneLoadingSubtitlePlaceholders}
        subTitleStyle={doneLoadingSubTitleStyle}
        failureIcon={doneLoadingFailureIcon}
        failureIconStyle={styles.failureIcon}
        {...resultModalFirstButtonProps}
        {...resultModalSecondButtonProps}
        modalHeight={this.state.modalHeight}
      />
    );
  };

  render() {
    const isResultModalVisible =
      !this.props.isLoading && !this.props.saveCardIsLoading && this.state.isDoneLoading;

    const isLoadingVisible = this.props.isLoading || this.props.saveCardIsLoading;

    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <ReactNativeModal
          isVisible={this.props.isVisible}
          backdropOpacity={0.5}
          onSwipeComplete={() => this.props.closeModal()}
          onBackdropPress={() => this.props.closeModal()}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              height: 'auto',
              minWidth: '600px',
              maxWidth: '600px',
              backgroundColor: this.props.theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              borderRadius: '7px',
            }}
            onStartShouldSetResponder={() => true}>
            {this.renderContent(isLoadingVisible, isResultModalVisible)}
          </View>
        </ReactNativeModal>
      )
    }

    return (
      <QuickActionMenu {...this.getQamProps(isLoadingVisible, isResultModalVisible)}>
        {this.renderContent(isLoadingVisible, isResultModalVisible)}
      </QuickActionMenu>
    );
  }
}

MyPlanExtrasModal.defaultProps = {
  toggleModal: () => { },
  isVisible: false,
  closeModal: () => { },
  type: Types.PRIMARY,
  paymentTypeOptions: [],
  paymentAmountFirstTypeOptions: [],
  paymentAmountSecondTypeOptions: [],
  handlePaymentFooterIconPress: () => { },
  confirmButtonType: Types.PRIMARY,
  handleConfirmButtonPress: () => { },
  cancelButtonType: Types.SECONDARY,
  handleCancelButtonPress: () => { },
  doneLoadingPrimaryButtonType: Types.PRIMARY,
  doneLoadingPrimaryButtonAction: () => { },
  theme: LightThemeColors,
  doneLoadingSecondaryButtonType: Types.SECONDARY,
};

MyPlanExtrasModal.propTypes = {
  defaultPayment: PropTypes.object,
  onSelectDefaultCard: PropTypes.func,
  onPressOpenCardList: PropTypes.func,
  paymentOptions: PropTypes.object,
  onPressAddCard: PropTypes.func,
  onPressSaveCard: PropTypes.func,
  onBackButtonPress: PropTypes.func,
  toggleModal: PropTypes.func,
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  isLoading: PropTypes.bool,
  saveCardIsLoading: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string,
  paymentTypeTitle: PropTypes.string,
  paymentTypeTitleStyle: ViewPropTypes.style,
  paymentTypeOptions: PropTypes.array,
  paymentAmountTitle: PropTypes.string,
  paymentAmountFirstTypeOptions: PropTypes.array,
  paymentAmountSecondTypeOptions: PropTypes.array,
  paymentMethodTitle: PropTypes.string,
  paymentMethodTitleStyle: ViewPropTypes.style,
  paymentFooterTitle: PropTypes.string,
  paymentFooterIcon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      uri: PropTypes.string.isRequired,
    }),
  ]),
  handlePaymentFooterIconPress: PropTypes.func,
  paymentFooterFirstTypeDescription: PropTypes.string,
  paymentFooterSecondTypeDescription: PropTypes.string,
  confirmButtonType: PropTypes.string,
  confirmButtonTitle: PropTypes.string,
  handleConfirmButtonPress: PropTypes.func,
  cancelButtonType: PropTypes.string,
  cancelButtonTitle: PropTypes.string,
  handleCancelButtonPress: PropTypes.func,
  loadingMessage: PropTypes.string,
  loadingMessageTextStyle: TextPropTypes.style,
  isLoadingSuccessful: PropTypes.bool,
  doneLoadingFailureIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  doneLoadingMainTitle: PropTypes.string,
  doneLoadingMainTitleStyle: TextPropTypes.style,
  doneLoadingSubTitle: PropTypes.string,
  doneLoadingSubtitlePlaceholders: PropTypes.array,
  doneLoadingSubTitleStyle: TextPropTypes.style,
  doneLoadingPrimaryButtonType: PropTypes.string,
  doneLoadingPrimaryButtonText: PropTypes.string,
  doneLoadingPrimaryButtonAction: PropTypes.func,
  withDoneLoadingSecondaryButton: PropTypes.bool,
  doneLoadingSecondaryButtonType: PropTypes.string,
  doneLoadingSecondaryButtonText: PropTypes.string,
  doneLoadingSecondaryButtonAction: PropTypes.func,
  isResetData: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  paymentCards: PropTypes.arrayOf(
    PropTypes.shape({
      brand: PropTypes.string,
      lastFourDigits: PropTypes.string,
      cardName: PropTypes.string,
      expiry: PropTypes.string,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    }),
  ),
  isPaymentMethod: PropTypes.bool,
  renderCustomPaymentMethod: PropTypes.func,
  footerDescriptionStyle: TextPropTypes.style,
  headerStyle: ViewPropTypes.style,
  paymentTypeSectionContainerStyle: ViewPropTypes.style,
  paymentAmountContainerStyle: ViewPropTypes.style,
  loadingLottieViewStyle: ViewPropTypes.style,
  btnsContainerStyle: ViewPropTypes.style,
  onTryAgainPress: PropTypes.func,
  onGoBackPress: PropTypes.func,
  isPlansExtrasLoading: PropTypes.bool,
  plansExtrasError: PropTypes.shape({
    message: PropTypes.string,
  }),
  plansExtrasErrorScreenProps: PropTypes.shape({
    title: PropTypes.string,
    onPrimaryBtnPress: PropTypes.func,
    primaryBtnTitle: PropTypes.string,
  }),
};

export default withTheme(MyPlanExtrasModal);
